import { ChartECOption } from '../types';

export interface GetChartYAxisOptionArgs {
  minYValue: number;
  maxYValue: number;
  hasNegativeValues: boolean;
  hasPositiveValues: boolean;
}

export function getChartYAxisOption({
  minYValue,
  maxYValue,
  hasNegativeValues,
  hasPositiveValues,
}: GetChartYAxisOptionArgs): ChartECOption['yAxis'] {
  return [
    {
      axisLabel: { show: false },
      min: Math.min(0, minYValue),
      max: hasNegativeValues && !hasPositiveValues ? -1 * minYValue : maxYValue,
      splitLine: { show: false },
      axisLine: { show: false },
      type: 'value',
      interval: (hasPositiveValues ? Math.abs(maxYValue) / 4 : 0) + (hasNegativeValues ? Math.abs(minYValue) / 4 : 0),
      position: 'right',
      minInterval: 4,
    },
  ];
}
